import React, { useState } from 'react'
import { Stack, Typography, FormControl, Button, Modal, TextField, Select, InputLabel, MenuItem, useMediaQuery } from '@mui/material'
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { NumericFormat } from 'react-number-format';
import dayjs from 'dayjs';
import { MobileDateTimePicker, viVN } from '@mui/x-date-pickers';
import { hasPermission } from '../../../../utils/utils';
import { authAtom } from '../../../../actions';
import { useAtomValue } from 'jotai';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const methods = [
    { name: 'Ví Anhdior', id: 1, disabled: true },
    { name: 'Tiền mặt', id: 2 },
    { name: 'Chuyển khoản', id: 5 },
    { name: 'Quẹt thẻ', id: 6 },
]

const types = [
    { name: 'Thanh toán toàn bộ', id: 1 },
    { name: 'Đặt cọc', id: 2 },
    { name: 'Thanh toàn còn lại', id: 3 },
    { name: 'Thanh toán thêm một phần', id: 4 },
    { name: 'Hoàn tiền', id: 5 },
]

const ConfirmPaymentModal = ({ payment, onAddPayment, handleClose, open }) => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const [time, setTime] = useState(dayjs(payment.payment_date));
    const [note, setNote] = useState(payment.note);
    const [amount, setAmount] = useState(payment.amount);
    const [type, setType] = useState(payment.payment_type);
    const [method, setMethod] = useState(payment.payment_method);
    const [order, setOrder] = useState(payment.lead_order.id);
    const auth = useAtomValue(authAtom);

    const onAdd = () => {
        onAddPayment({
            ...payment,
            lead_order: order,
            payment_date: dayjs(time).format(),
            amount: amount,
            note: note,
            payment_type: type,
            payment_method: method,
        });
    };

    const onClose = () => {
        if (handleClose) {
            handleClose();
        }
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? '90%' : 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: isMobile ? 2 : 4,
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Stack spacing={2} sx={modalStyle}>
                <Typography variant="h6" textAlign="center">
                    Thông tin thanh toán
                </Typography>
                <TextField
                    label="Đơn hàng"
                    variant="outlined"
                    placeholder="Đơn hàng"
                    value={order}
                    onChange={(e) => setOrder(e.target.value)}
                    disabled={!hasPermission(auth, ['change_payment_order']) || payment.payment_method === 1}
                />
                <FormControl fullWidth>
                    <InputLabel id="type-select-label">Loại thanh toán</InputLabel>
                    <Select
                        labelId="type-select-label"
                        id="type-select"
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                    >
                        {types.map((item) => (
                            <MenuItem key={item.id} value={item.id}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl fullWidth disabled={payment.payment_method === 1}>
                    <InputLabel id="method-select-label">Hình thức thanh toán</InputLabel>
                    <Select
                        labelId="method-select-label"
                        id="method-select"
                        value={method}
                        onChange={(e) => setMethod(e.target.value)}
                    >
                        {methods.map((item) => (
                            <MenuItem key={item.id} value={item.id} disabled={item.disabled}>
                                {item.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <NumericFormat
                    customInput={TextField}
                    label="Số tiền thanh toán"
                    thousandSeparator="."
                    decimalSeparator=","
                    suffix="đ"
                    variant="outlined"
                    placeholder="Số tiền thanh toán"
                    value={amount}
                    onValueChange={(values) => setAmount(parseFloat(values.value))}
                />
                <TextField
                    label="Ghi chú"
                    fullWidth
                    multiline
                    rows={3}
                    variant="outlined"
                    placeholder="Ghi chú"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                />
                <LocalizationProvider
                    dateAdapter={AdapterDayjs}
                    localeText={viVN.components.MuiLocalizationProvider.defaultProps.localeText}
                    adapterLocale="vi"
                >
                    <MobileDateTimePicker
                        label="Thời gian thanh toán"
                        value={time}
                        onChange={(value) => setTime(value)}
                        format="HH:mm DD/MM/YYYY"
                    />
                </LocalizationProvider>
                <Stack flexDirection='row' gap={2} alignItems="center" justifyContent="center">
                    <Button onClick={handleClose} color="warning" sx={{flex: 1}} variant="outlined">
                        Huỷ
                    </Button>
                    <Button
                        onClick={onAdd}
                        color="success"
                        sx={{flex: 1, mt: '0px !important'}}
                        variant="contained"
                        disabled={!time || !type || !method}
                    >
                        Xác nhận
                    </Button>
                </Stack>
                {payment.lead_order.id !== order && (
                    <Typography sx={{ color: 'red', fontSize: '11px', textAlign: 'center' }}>
                        Cảnh báo: Đơn hàng gốc của thanh toán đã được thay đổi. Vui lòng kiểm tra thay đổi này là đúng trước khi xác nhận.
                    </Typography>
                )}
            </Stack>
        </Modal>
    );
};

export default ConfirmPaymentModal;